import type { Locale } from './i18n';
import { currentLocale, getLocale, setLocale, t } from './i18n';

export function useTranslation() {
  // Reading .value subscribes the component to locale changes
  const locale = currentLocale.value;

  return {
    t,
    locale: locale as Locale,
    setLocale,
    getLocale,
  };
}
